import styled from "styled-components";

export const PhoneMultiHeroBanner = styled.div`
  margin-top: 16px;
  position: relative;
  display: grid;
  flex-direction: row;
  flex-wrap: wrap;
  grid-template:
    'one';
`;
